import { Component } from '@angular/core';

/**
 * Page wrapper for the main tasks list view.
 * Enables filter persistence with a dedicated storage key.
 */
@Component({
  selector: 'app-tasks-page',
  template: `
    <tasks-list 
      filterStorageKey="tasks-page-filters">
    </tasks-list>
  `
})
export class TasksPageComponent {}
